import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

class OktaRedirect extends Component {
  constructor(props) {
    super(props);

    const token = qs.parse(window.location.hash.substring(1)); // parse everything after the '#'
    const accessValues = token.access_token.split('.');
    const openIdValues = token.id_token.split('.');
    const accessClaims = JSON.parse(window.atob(accessValues[1]));
    logger.log(accessClaims)
    const openIdClaims = JSON.parse(window.atob(openIdValues[1]));
    logger.log(openIdClaims)


    props.onLogin(
      {
        accessToken: token.access_token,
        openIdToken: token.id_token,
        expiresIn: token.expires_in,
        expiresAt: accessClaims.exp,
        username: accessClaims.sub,
        email: openIdClaims.email,
        name: openIdClaims.name,
        // scope: accessClaims.scp,
      },
      () => props.history.push(props.redirectPath),
    );
  }

  render() {
    return (
      <div>
        <h3>Redirected from Okta, loggedIn</h3>
        <div style={{ padding: '2em' }}>
          <strong>Props: User</strong>
          <pre>{JSON.stringify(this.props.user, null, 2)}</pre>
        </div>
      </div>
    );
  }
}

OktaRedirect.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }),
  onLogin: PropTypes.func.isRequired,
  redirectPath: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
};

// prettier-ignore
// export default props => (
//   <UserContext.Consumer>
//     {user => <OktaRedirect {...props} user={user} />}
//   </UserContext.Consumer>
// );

export default OktaRedirect;



// WEBPACK FOOTER //
// ./src/containers/OktaRedirect/OktaRedirect.js